<script setup>
// License pages: license-attribute catalog (franchises/IPs like Harry Potter,
// Pokémon). All logic lives in the shared EntityCatalog component (also used
// by /publisher).
</script>

<template>
  <EntityCatalog entity="license" />
</template>
